export default {
  getAnnounces: "/cms/api",
}
